import React from 'react';
export default class MinimalResumeSummary extends React.Component{
    render(){
        return  <div data-v-2568b4c2="" className="section">
                    <div data-v-2568b4c2="" className="section-description" dangerouslySetInnerHTML={{ __html: this.props.data.description }}></div>
                </div>
    }
}